import PropTypes from "prop-types";

export default function StepIndicator({ className = "", steps = 0, activeStep, hasLabels = false, stepLabels = [] }) {
  return (
    <ol
      className={`step-indicator ${className}${hasLabels ? " has-labels" : ""}`}
      aria-label={`Step ${activeStep} of ${steps}`}
    >
      {Array.from(Array(steps).keys()).map((step, idx) => {
        const stepNumber = step + 1;
        const isActive = stepNumber === activeStep;
        const isComplete = stepNumber < activeStep;
        const status = isActive ? "current" : isComplete ? "complete" : "upcoming";
        const label = stepLabels[idx];
        return (
          <li
            key={idx}
            className={`step${isComplete ? " complete" : ""}${isActive ? " active" : ""}`}
            aria-current={isActive ? "step" : undefined}
            aria-label={label ? `${label} (${status})` : `Step ${stepNumber} (${status})`}
          >
            {hasLabels && <div className="step-label">{label ?? ""}</div>}
          </li>
        );
      })}
    </ol>
  );
}

StepIndicator.prototype = { className: PropTypes.string, steps: PropTypes.number, activeStep: PropTypes.number };
